/*
 * Enhances Shopify's native <shopify-payment-terms> (Shop Pay Installments / Affirm).
 *
 * Shop Pay: keep the native widget — only fix logo visibility (Tailwind classes inside
 * the shadow root are inert without Shopify's bundle) and leave #shopify-installments-cta
 * untouched so its aria-haspopup dialog / Learn more modal keeps working.
 *
 * Affirm (legacy bar layout): inject Figma bar styles into the shadow root for PLP hosts.
 *
 * The component is rendered via Liquid {{ form | payment_terms }}; eligibility and
 * pricing come from Shopify Payments — no theme API keys.
 */
(function () {
  'use strict';

  var STYLE_ATTR = 'data-bnpl-styles';
  var STYLE_MODE_ATTR = 'data-bnpl-mode';

  /* Shop Pay — minimal visibility; do NOT restyle the CTA (native modal). */
  var SHOP_PAY_CSS = [
    ':host{display:block !important;visibility:visible !important;width:100% !important;',
    'font-size:14px !important;color:#252525 !important;}',
    ':host > p{display:flex !important;flex-wrap:wrap !important;align-items:center !important;',
    'gap:4px 8px !important;margin:0 !important;width:100% !important;line-height:1.25 !important;}',
    '#shopify-installments-content{display:inline !important;visibility:visible !important;',
    'color:#252525 !important;font-size:14px !important;line-height:1.25 !important;}',
    '#shopify-installments-content .font-bold{font-weight:700 !important;}',
    '#shopify-installments-content div{display:inline-flex !important;align-items:center !important;',
    'vertical-align:middle !important;color:#5a31f4 !important;}',
    '#shopify-installments-content svg{display:block !important;height:14px !important;',
    'width:59px !important;color:#5a31f4 !important;fill:currentColor !important;}',
    '#shopify-installments-cta{flex-shrink:0 !important;}',
  ].join('');

  /* Affirm / legacy compact bar — message left, bordered Learn more right. */
  var AFFIRM_BAR_CSS = [
    ':host{display:block !important;width:100% !important;background:transparent !important;',
    'font-size:14px !important;color:#252525 !important;}',
    ':host > :not(style),.shopify-payment-terms{display:flex !important;',
    'align-items:center !important;justify-content:space-between !important;gap:8px !important;',
    'flex-wrap:wrap !important;width:100% !important;}',
    'p,span,.shopify-payment-terms__purchase{color:#252525 !important;font-size:14px !important;',
    'line-height:1.25 !important;margin:0 !important;}',
    '#prequalAmountContainer{display:none !important;}',
    'a,button,[role="button"]:not(#shopify-installments-cta){display:inline-flex !important;',
    'align-items:center !important;justify-content:center !important;height:25px !important;',
    'padding:0 10px !important;border:1px solid #252525 !important;border-radius:3px !important;',
    'background:transparent !important;color:#252525 !important;font-size:14px !important;',
    'font-weight:600 !important;text-transform:capitalize !important;text-decoration:none !important;',
    'white-space:nowrap !important;cursor:pointer !important;}',
    'a:hover,button:hover,[role="button"]:not(#shopify-installments-cta):hover{',
    'background:#252525 !important;color:#fff !important;}',
  ].join('');

  /* Shop Pay — PLP card bar (12px Figma type + bordered Learn more) */
  var SHOP_PAY_PLP_EXTRA = [
    ':host > p{justify-content:space-between !important;width:100% !important;}',
    '#shopify-installments-content{font-size:12px !important;line-height:1.1 !important;}',
    '#shopify-installments-content svg{height:11px !important;width:46px !important;}',
    '#shopify-installments-cta{display:inline-flex !important;align-items:center !important;',
    'justify-content:center !important;flex-shrink:0 !important;height:16px !important;',
    'padding:0 6.5px !important;border:0.65px solid #252525 !important;border-radius:2px !important;',
    'background:transparent !important;color:#252525 !important;font-size:12px !important;',
    'font-weight:600 !important;line-height:1 !important;text-transform:capitalize !important;',
    'cursor:pointer !important;}',
    '#shopify-installments-cta:hover{background:#252525 !important;color:#fff !important;}',
  ].join('');

  function detectMode(root) {
    if (!root) return 'affirm';
    if (root.querySelector('#shopify-installments-content')) return 'shop_pay';
    return 'affirm';
  }

  function injectShadowStyles(el) {
    var root = el && el.shadowRoot;
    if (!root) return false;

    var mode = detectMode(root);
    var css = mode === 'shop_pay' ? SHOP_PAY_CSS : AFFIRM_BAR_CSS;
    if (mode === 'shop_pay' && el.closest && el.closest('.plp-payments__shopify-host')) {
      var plpHost = el.closest('.plp-payments__shopify-host');
      if (!plpHost.classList.contains('plp-payments__shopify-host--sr')) {
        css += SHOP_PAY_PLP_EXTRA;
      }
    }
    var existing = root.querySelector('style[' + STYLE_ATTR + ']');

    if (existing) {
      if (existing.getAttribute(STYLE_MODE_ATTR) === mode) return true;
      existing.remove();
    }

    var style = document.createElement('style');
    style.setAttribute(STYLE_ATTR, '');
    style.setAttribute(STYLE_MODE_ATTR, mode);
    style.textContent = css;
    root.appendChild(style);
    return true;
  }

  function styleAll() {
    document.querySelectorAll('shopify-payment-terms').forEach(function (el) {
      if (!injectShadowStyles(el)) {
        setTimeout(function () {
          injectShadowStyles(el);
        }, 200);
      }
    });
  }

  window.styleShopifyPaymentTerms = styleAll;

  var PLP_SECTION = 'algolia-plp-payment-terms';
  var plpCache = window.__plpPaymentTermsCache || (window.__plpPaymentTermsCache = {});

  function pickPaymentTermsHtml(json) {
    if (!json || typeof json !== 'object') return '';
    if (json[PLP_SECTION]) return json[PLP_SECTION];
    var keys = Object.keys(json);
    var match = keys.find(function (k) {
      return k === PLP_SECTION || k.indexOf(PLP_SECTION) !== -1;
    });
    return match ? json[match] : '';
  }

  function extractPaymentTermsInner(htmlFragment) {
    if (!htmlFragment) return '';
    var doc = new DOMParser().parseFromString(htmlFragment, 'text/html');
    var root = doc.querySelector('.algolia-plp-payment-terms-root');
    if (root) return root.innerHTML;
    var section = doc.querySelector('[id^="shopify-section-"]');
    if (section) {
      var innerRoot = section.querySelector('.algolia-plp-payment-terms-root');
      return innerRoot ? innerRoot.innerHTML : section.innerHTML;
    }
    return htmlFragment;
  }

  function restyleSoon() {
    scheduleStyle();
    [150, 450, 1200].forEach(function (delay) {
      setTimeout(styleAll, delay);
    });
  }

  /**
   * Inject native shopify-payment-terms into a PLP card host element.
   * Returns a Promise<boolean> — true when terms HTML was injected.
   */
  window.loadPlpPaymentTerms = function (hostEl, handle, variantId) {
    if (!hostEl || !handle || !variantId) return Promise.resolve(false);

    var cacheKey = String(handle) + '::' + String(variantId);
    if (plpCache[cacheKey]) {
      hostEl.innerHTML = plpCache[cacheKey];
      restyleSoon();
      return Promise.resolve(true);
    }

    var root = String(window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(
      /\/?$/,
      '/'
    );
    var reqUrl =
      root +
      'products/' +
      encodeURIComponent(handle) +
      '?sections=' +
      encodeURIComponent(PLP_SECTION) +
      '&variant=' +
      encodeURIComponent(String(variantId));

    return fetch(reqUrl, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('payment terms section');
        return r.json();
      })
      .then(function (json) {
        var inner = extractPaymentTermsInner(pickPaymentTermsHtml(json));
        if (!inner || inner.trim().length < 20) throw new Error('empty payment terms');
        hostEl.innerHTML = inner;
        plpCache[cacheKey] = inner;
        restyleSoon();
        return true;
      })
      .catch(function () {
        hostEl.innerHTML = '';
        return false;
      });
  };

  var rafScheduled = false;
  function scheduleStyle() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(function () {
      rafScheduled = false;
      styleAll();
    });
  }

  function init() {
    styleAll();
    [150, 450, 1200].forEach(function (delay) {
      setTimeout(styleAll, delay);
    });

    var observer = new MutationObserver(scheduleStyle);
    observer.observe(document.body, { childList: true, subtree: true });

    function restyleOnVariantChange() {
      restyleSoon();
    }
    document.addEventListener('variant:changed', restyleOnVariantChange);
    document.addEventListener(
      'change',
      function (e) {
        if (e.target && e.target.matches && e.target.matches('input[name="id"]')) {
          restyleOnVariantChange();
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
